import { Component, computed, input } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  standalone: true,
  imports: [MatDivider, NgxSkeletonLoaderModule],
  selector: 'suvo-skeleton-table-rows',
  template: `
    @for (random of rowRandomBasisValues(); track $index) {
      <div class="cell-container">
        @for (basis of colBasisValues(); track $index) {
          <div class="cell" [style.flexBasis]="basis + '%'">
            <ngx-skeleton-loader
              [theme]="{
                height: '18px',
                width: random + '%',
                'border-radius': '22px',
              }"
            />
          </div>
        }
      </div>

      @if (!$last) {
        <mat-divider />
      }
    }
  `,
  styles: `
    .cell-container {
      display: flex;
      flex-flow: row nowrap;
      height: 41px;

      .cell {
        padding: 14px 3px;
        flex: 1 1;

        &:first-of-type {
          padding-left: 24px;
        }
      }
    }

    @media screen and (max-width: 600px) {
      .cell:not(:first-of-type) {
        display: none;
      }
    }
  `,
})
export class SkeletonTableRowsComponent {
  readonly colCount = input(1);
  readonly rowCount = input(7);

  readonly colWidths = input<number[]>();

  readonly rowRandomBasisValues = computed(() =>
    Array.from({ length: this.rowCount() }, () => Math.floor(Math.random() * 50 + 40)),
  );

  readonly colBasisValues = computed(() => {
    const colCount = this.colCount();
    const equalBasis = 100 / colCount;
    return this.colWidths() ?? Array.from({ length: colCount }, () => equalBasis);
  });
}
